import { render } from "./TextEditor.vue?vue&type=template&id=0f6ff2cc"
import script from "./TextEditor.vue?vue&type=script&lang=ts"
export * from "./TextEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script